import React from 'react'
import { observer } from 'mobx-react-lite'
import { Scrollbar, Divider, Alert } from 'shared/ui'
import { BrandInfoSection } from './BrandInfoSection/BrandInfoSection'
import { BrandLogoSection } from './BrandLogoSection/BrandLogoSection'
import { BrandContactSection } from './BrandContactSection/BrandContactSection'

import styles from './styles.module.scss'
import { BrandTermsSection } from './BrandTermsSection/BrandTermsSection'

export const RcsCreateProfile: React.FC = observer(() => {
  return (
    <Scrollbar>
      <div className={styles.container}>
        <Alert
          item={{
            type: 'warning',
            desc: 'RCS works only in the U.S. for now',
          }}
        />
        <BrandInfoSection />
        <Divider sx={{ borderColor: 'var(--black-10)' }} />
        <BrandLogoSection />
        <Divider sx={{ borderColor: 'var(--black-10)' }} />
        <BrandContactSection />
        <Divider sx={{ borderColor: 'var(--black-10)' }} />
        <BrandTermsSection />
      </div>
    </Scrollbar>
  )
})
